(function (d) {
    var wf = d.createElement("script"), s = d.scripts[0];
    wf.src = "https://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js";
    s.parentNode.insertBefore(wf, s)
})(document);

var urllink="https://"+Shopify.shop+"/tools/cartscarcity/storeinterfacelayout.php?shop="+Shopify.shop;

var db_Obj = {guid: "5726b9a23dbc7", sid: "39", source: "shopify", url: urllink};
var db_content = {};
var dbar_cart;


var stylehead = ".tb{ background : #000; color : #fff; right : 0px; top : 0px; left: 0px; position: fixed; z-index: 9999999999; opacity: 0; font-size: 17px; line-height: 37px;}.col{display:inline-block;vertical-align:middle;text-align:center}.col1,.col3{width:9%}.col2{width:80%}.ds,.fp{display:block}#timercontrol{font-weight:700}#dbardiscountdiv{padding:5px;}";
var timespent = 0;
var timerrunning = false;



function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return "";
}

var formatMoney = function (t, e) {
    function n(t, e) {
        return "undefined" == typeof t ? e : t
    }

    function r(t, e, r, i) {
        if (e = n(e, 2), r = n(r, ","), i = n(i, "."), isNaN(t) || null == t)
            return 0;
        t = (t / 100).toFixed(e);
        var o = t.split("."),
                a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r),
                s = o[1] ? i + o[1] : "";
        return a + s
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var i = "",
            o = /\{\{\s*(\w+)\s*\}\}/,
            a = e || db_content.moneyFormat;
    switch (a.match(o)[1]) {
        case "amount":
            i = r(t, 2);
            break;
        case "amount_no_decimals":
            i = r(t, 0);
            break;
        case "amount_with_comma_separator":
            i = r(t, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = r(t, 0, ".", ",")
    }
    return a.replace(o, i)
}


function getTimespent(ts) {
    var c_ts = getCookie("d_timespent");
    if (c_ts != "") {
        c_ts = parseInt(c_ts);
        return c_ts;
    }
    return ts;
}

function runTimer() {
    timespent++;
    setTimeout(function () {
        var t = db_content.interval - timespent;
        var m = parseInt(t / 60);
        var s = t - m * 60;
        dbarJquery('#timercontrol').html(m + " : " + s);
        setCookie('d_timespent', timespent, 30);
        if (t == 0) {
            dbarJquery('#tb').slideUp();
            removeDiscount();
            dbarJquery('#dbardiscountdiv').html('').hide();
            timerrunning = false;
        }
        else {
            runTimer();
        }
    }, 1000);
}

function removeDiscount() {
    dbarJquery('form[action="/cart"]').each(function () {
        var discount = dbarJquery(this).find('input[name="discount"]');
        if (discount.length > 0) {
            discount.val('');
        }

    });
}

function createTopbar() {

    var topbar = dbarJquery('<div id="tb">');
    if (dbarJquery('#tb').length > 0) {
        topbar = dbarJquery('#tb');
    }

    topbar.addClass('tb');
    var div = dbarJquery('<div class="col col1">');
    if (db_content.discountType === "percentage") {
        div.append(db_content.discount + " %");
    }
    else {
        div.append(formatMoney(parseFloat(db_content.discount * 100), ""));
    }
    topbar.append(div);
    var div = dbarJquery('<div class="col col2">');
    div.append(db_content.message);
    topbar.append(div);
    var div = dbarJquery('<div class="col col3" id="timercontrol">');
    topbar.append(div);
    dbarJquery('body').append(topbar);
    topbar.css('background', db_content.bgcolor);
    topbar.css('color', db_content.textcolor);
    topbar.css('font-family', db_content.fontfamily);
    topbar.css('font-size', db_content.fontsize);
    topbar.css('font-weight', db_content.fontweight);
    runTimer();
    topbar.slideUp('fast', function () {
        topbar.css('opacity', '1');
        topbar.slideDown();
    });
}

function addDiscount() {
    dbarJquery('form[action="/cart"]').each(function () {
        var discount = dbarJquery(this).find('input[name="discount"]');
        var input = dbarJquery('<input>');
        if (discount.length > 0) {
            input = discount;
        }

        input.attr('type', 'hidden').attr('name', 'discount');
        dbarJquery(this).append(input);
        dbarJquery(input).val(db_content.discountCode);

        var checkoutdiv = dbarJquery('input[name="checkout"]').closest('div');


        var ds = dbarJquery('<div class="ds">');
        var fp = dbarJquery('<div class="fp">');

        if (db_content.discountType === "percentage") {
            var finalprice = (dbar_cart.total_price - (dbar_cart.total_price * parseInt(db_content.discount)) / 100) / 100;
            var discount = parseInt(db_content.discount + ' %');
            ds.append('Discount : ' + discount + "%<br>");
            fp.append('Final Price : ' + formatMoney(parseFloat(finalprice * 100), "") + "<br>");
        }
        else {
            var finalprice = (dbar_cart.total_price - parseInt(db_content.discount * 100)) / 100;
            var discount = parseInt(db_content.discount * 100) / 100;
            ds.append('Discount : ' + formatMoney(parseFloat(discount * 100), "") + "<br>");
            fp.append('Final Price : ' + formatMoney(parseFloat(finalprice * 100), "") + "<br>");
        }
        var discountdiv = dbarJquery('<div id="dbardiscountdiv">');
        if (dbarJquery('#dbardiscountdiv').length > 0) {
            discountdiv = dbarJquery('#dbardiscountdiv');
            discountdiv.append(ds);
            discountdiv.append(fp);
        }
        else {
            discountdiv = dbarJquery('<div id="dbardiscountdiv">');
            discountdiv.html('');
            discountdiv.append(ds);
            discountdiv.append(fp);
            discountdiv.insertBefore(checkoutdiv);
        }
        discountdiv.css('background', db_content.bgcolor);
        discountdiv.css('color', db_content.textcolor);
    });
}
function getCartValue() {
    dbarJquery.getJSON('/cart.js', function (cart) {
        dbar_cart = cart;
        if (cart.item_count > 0) {
            dbarJquery('form[action="/cart"]').each(function () {
                if (!timerrunning) {
                    createTopbar();
                    timerrunning = true;
                }
                else {

                }
                addDiscount();
            });
        }
    });
}


function AddstylesheetCode() {
    dbarJquery("<style>" + stylehead + "</style>").appendTo("head");
}

initializedbar = function () {

  
    dbarJquery.get(db_Obj.url, {guid: db_Obj.guid, sid: db_Obj.sid}, function (json) {

        var retobj = JSON.parse(json);
        db_content = JSON.parse(retobj.data.bardata);
var m = parseInt(db_content.timer.minutes) || 0;
        var s = parseInt(db_content.timer.seconds) || 0;
        db_content.interval = m * 60 + s;
        console.log(db_content);
        // font loading code
        WebFontConfig = {
            google: {
                families: [db_content.fontfamily]
            },
            loaded: function () {

            }
        };
        timespent = getTimespent(timespent);

        if (timespent < db_content.interval) {
            AddstylesheetCode();
            getCartValue();
        }
    });
};

var jQueryLoaded = function (dbarJquery) {
    initializedbar();

};

function dbar() {
    var arr = jQuery.fn.jquery.split(".");
    if (1 < arr[0] || 1 == arr[0] && 7 < arr[1]) {
        dbarJquery = jQuery;
        jQueryLoaded(jQuery);
    }
    else {
        loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js", function () {
            dbarJquery = jQuery.noConflict(!0);
            jQueryLoaded(dbarJquery);
        });
    }
}

window.dbarJquery = jQuery;
window.loaddbar = function () {
    setTimeout(function () {
        dbar();
    }, 1000);
}

window.loaddbar();